import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-563b4ce0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
import { computed, watch } from 'vue';
import { ref, reactive } from 'vue';

// 定义父组件传递的属性

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true
    },
    end_date: {
      type: String,
      default: ''
    }
  },
  emits: ['update:show', 'conformDate'],
  setup(__props, {
    emit
  }) {
    const props = __props;

    /* eslint-disable no-undef */

    // 定义emits

    const datePickerRef = ref(null);

    // picker依赖show状态
    const showPicker = computed({
      get() {
        return props.show;
      },
      set(value) {
        emit('update:show', value);
      }
    });
    const currentDate = ref([]);
    const currentTime = ref(['']);

    // 最小日期：明天
    const current_date = new Date();
    const minDate = new Date(current_date);
    minDate.setDate(current_date.getDate() + 1);

    // 最大日期：传入的 end_date 或默认 22 天后
    const maxDate = ref(new Date(current_date.getTime() + 22 * 24 * 60 * 60 * 1000));
    watch(() => props.end_date, newValue => {
      if (newValue) {
        const endDate = new Date(newValue.replace(/-/g, '/'));
        // 确保 endDate 是有效日期
        if (!isNaN(endDate.getTime())) {
          maxDate.value = endDate;
        }
      }
    }, {
      immediate: true
    });

    // 时间列数类型：小时和分钟
    const timeColumnsType = ['hour', 'minute'];
    const formatter = (type, option) => {
      if (type === 'year') {
        option.text += '年';
      } else if (type === 'month') {
        option.text += '月';
      } else if (type === 'day') {
        option.text += '日';
      } else if (type === 'hour') {
        option.text += '时';
      } else if (type === 'minute') {
        option.text += '分';
      }
      return option;
    };
    const themeVars = reactive({
      popupRoundRadius: '12px',
      pickerToolbarHeight: '48px',
      pickerActionFontSize: '14px',
      pickerConfirmActionColor: '#00C4A1',
      tabFontSize: '15px',
      tabsBottomBarColor: '#000000',
      tabsBottomBarWidth: '24px',
      pickerOptionFontSize: '18px'
    });
    function onConfirm() {
      showPicker.value = false;

      // 格式化日期和时间
      const year = currentDate.value[0];
      const month = String(currentDate.value[1]).padStart(2, '0');
      const day = String(currentDate.value[2]).padStart(2, '0');
      const hour = String(currentTime.value[0]).padStart(2, '0');
      const minute = String(currentTime.value[1] || '00').padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      const formattedTime = `${hour}:${minute}`;
      console.log('onConfirm----', formattedDate, formattedTime);
      emit('conformDate', {
        'date': formattedDate,
        'time': formattedTime,
        'datetime': `${formattedDate} ${formattedTime}:00`
      });
    }
    return (_ctx, _cache) => {
      const _component_van_date_picker = _resolveComponent("van-date-picker");
      const _component_van_time_picker = _resolveComponent("van-time-picker");
      const _component_van_picker_group = _resolveComponent("van-picker-group");
      const _component_van_popup = _resolveComponent("van-popup");
      const _component_van_config_provider = _resolveComponent("van-config-provider");
      return _openBlock(), _createBlock(_component_van_config_provider, {
        "theme-vars": _unref(themeVars)
      }, {
        default: _withCtx(() => [_createVNode(_component_van_popup, {
          show: _unref(showPicker),
          "onUpdate:show": _cache[3] || (_cache[3] = $event => _isRef(showPicker) ? showPicker.value = $event : null),
          round: "",
          position: "bottom"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_picker_group, {
            title: "选择开奖时间",
            tabs: ['日期', '时间'],
            "next-step-text": "确定",
            "confirm-button-text": "确定",
            onConfirm: onConfirm,
            onCancel: _cache[2] || (_cache[2] = $event => showPicker.value = false)
          }, {
            default: _withCtx(() => [_createVNode(_component_van_date_picker, {
              ref_key: "datePickerRef",
              ref: datePickerRef,
              modelValue: currentDate.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => currentDate.value = $event),
              formatter: formatter,
              "min-date": _unref(minDate),
              "max-date": maxDate.value,
              "option-height": "48"
            }, null, 8, ["modelValue", "min-date", "max-date"]), _createVNode(_component_van_time_picker, {
              modelValue: currentTime.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => currentTime.value = $event),
              formatter: formatter,
              "option-height": "48",
              "columns-type": timeColumnsType
            }, null, 8, ["modelValue"])]),
            _: 1
          })])]),
          _: 1
        }, 8, ["show"])]),
        _: 1
      }, 8, ["theme-vars"]);
    };
  }
};